module.exports = __webpack_public_path__ + "static/media/quantities-icon-active.e39407fc.svg";